module.exports = {
      id: "basket-usage",
      viewBox: "0 0 16.4 21.4",
      url: __webpack_public_path__ + "img/icons.05c569e2.svg#basket-usage",
      toString: function () {
        return this.url;
      }
    }